import { z } from "zod";

/**
 * An editable SEO slug on the brand, category and SKU edit screens. The shape check only — the
 * server is authoritative for GUID-shaped values, reserved words and uniqueness (422/409, shown
 * through the screen's ErrorSurface). Create screens have no slug field: the server assigns one.
 */
export const slugSchema = z
  .string()
  .min(1, "Required")
  .max(200, "200 characters at most")
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Lower-case letters and numbers, separated by single hyphens");

export const SLUG_HINT = "Changing it changes the public page address — links to the old address will stop working.";

/** The `slug` an update sends: the new value only when it changed, otherwise absent (unchanged). */
export function changedSlug(next: string, current: string): string | undefined {
  return next === current ? undefined : next;
}
